import React, { useEffect, useState } from 'react';
import Card from '../../components/Card/Card';
import DataTable from '../../components/DataTable/DataTable';
import { useNotifications } from '../../contexts/notificationContext';
import DataService from "../../services/data.service";

const Tenants: React.FC = () => {
    const [data, setData] = useState<any[]>();
    const { handleException } = useNotifications();

    useEffect(() => {
        getTableData();
    }, []);

    function getTableData() {
        DataService.get<any[]>('api/v1/tenants')
            .then(response => {
                setData(response);
            })
            .catch(e => { handleException(e); });
    }

    return (
        <div className='main-content'>
            <Card title='Tenants'
                content={
                    <DataTable
                        name='dtTenants'
                        tableData={data}
                        colInfos={[
                            { key: true, dataProp: 'id', visible: false },
                            { title: 'Name', dataProp: 'name', sort: 'asc', filterInfo: { filterType: 'Textbox' } },
                        ]}
                        navigateTitle='Tenant'
                        navigateUrl='/plm/appconfig/tenant/'
                    />
                }
            />
        </div>
    );
}
export default Tenants;